
import LoadingManagerGlobal from './assets/engine/loading/LoadingManagerGlobal.js'
import Lang from './lang.js';

export default class App {
    constructor() {

        this.debug = false

        this.currentOvername = null;

        this.startHash = "";

        this.visitor = {
            firstName: null,
            lastName: null,
            email: null,
            acknowledgePrivacy: false,
            hcp: false,
            acceptsNewsletter: false
        }

        document.addEventListener('olarkVisitorDetails', (e) => { 

            if(e.detail.details.customFields.acceptsNewsletter != undefined)
                this.visitor.acceptsNewsletter = e.detail.details.customFields.acceptsNewsletter;
            if(e.detail.details.customFields.firstName != undefined)
                this.visitor.firstName = e.detail.details.customFields.firstName;
            if(e.detail.details.customFields.lastName != undefined)
                this.visitor.lastName = e.detail.details.customFields.lastName;
            this.visitor.email = e.detail.details.emailAddress;
            //console.log('olark has give details', e.detail.details)
        })
        

        this.portrait = false;

        if(window.innerWidth < window.innerHeight)
            this.portrait = true

        // THREE SCENE objects, accessible everywhere
        this.renderer = null;
        this.hdrCubeMap = null;

        this.LoadingManagerGlobal = new LoadingManagerGlobal(this)
        this.lang = new Lang(this)

        this.dataLoaded = false;
        this.beginFormCompleted = false;
        this.privacyPageDisplay= false;
        this.cookiesPageDisplay= false;
        this.cookiesPopupDisplay = true;

        this.events = {
            startAll : new Event('startAll'),
            
            dataLoaded : new Event('dataLoaded'),
            objectsLoaded : new Event('objectsLoaded'),
            moveCamera: new Event('moveCamera'),
            playVideo: new Event('playVideo'),
            mapToggle: new Event('mapToggle'),
            moveToNextNode: new Event('moveToNextNode'),
            moveToPrevNode: new Event('moveToPrevNode'),
            contentPanelUpdated: new Event('contentPanelUpdated'),
            relatedPanelUpdated: new Event('relatedPanelUpdated'),
            hashChanged: new Event('hashChanged'),
            displayVideoPanel: new Event('displayVideoPanel'),
            hideVideoPanel: new Event('hideVideoPanel')
            //loader3DFinished: new Event('loader3DFinished')
        }

        this.currentNode = null;
        this.nextNode = null;
        this.prevNode = null;


        this.viewMode = {
            nav: true,
            map: false,
            product: false
        }
        
        /**
         * Contains hierachy, nodes, scene params
         * from data/room.json
         */
        this.room = null;
        /**
         * App assets library (Textures, Materials, Meshes, Products, Systems)
         * from data/assets.json
         */
        this.assets= null;

        this.cameraParam = {
            fovNav: 55,
            fovProduct: 55,
            fovMap: 35
        }

        /*
        NODE TYPES
        0:     Start Node (Welcome). Must be unique
        1:     3D category
        2:     2D catgory
        3:     3D System
        4:     3D product
        5:     2D product
        */

        this.nodeParams = {
            distanceDefault : [
                600,    // 0
                500,    // 1
                500,    // 2
                160,    // 3
                160,    // 4
                160,    // 5
            ]
        }

        this.contentPanel = {
            title: '',
            subtitle: '',
            desc: '',
            contentHTML: ''
        }

        this.relatedPanel = {
            title: '',
            subtitle: '',
            desc: '',
            contentHTML: ''
        }

        this.contentPanelVisible = true;
        this.contentPanelOpen = false;
        this.relatedPanelOpen = false;
        if(!this.portrait)
            this.contentPanelOpen = true;

        this.menuOpen = false;

        this.help = {
            miniOpen: false,
            fullOpen: false
        }
        if(!this.portrait)
            this.help.miniOpen = true

        this.contents = null;

        this.video = {
            display:false,
            src: ''
        }

        this.nextLinkNoMovement = false;

        this.init();

        document.addEventListener('beginFormComplete', () => { 
            this.beginFormCompleted = true;
            ////console.log('beginFormComplete')
            ////console.log(this.dataLoaded)
            if(this.dataLoaded)
                document.dispatchEvent(this.events.startAll);
        })
        
        document.addEventListener('dataLoaded', () => { 
            this.dataLoaded = true;
            ////console.log('dataLoaded')
            ////console.log(this.beginFormCompleted)
            if(this.beginFormCompleted)
                document.dispatchEvent(this.events.startAll);
        })
        
    }

    init() {

        var baseDataLoad= {
            room: false,
            assets: false
        }

        this.LoadingManagerGlobal.loadFile('data/assets.json', true, (data) => {
            this.assets = data;
            //console.log('assets data loaded');
            baseDataLoad.assets = true;

            if(baseDataLoad.room && baseDataLoad.assets)
                document.dispatchEvent(this.events.dataLoaded);
        },
        (error) => {
            console.log('Error loading assets info', error)
        })

        this.LoadingManagerGlobal.loadFile('data/room.json', true, (data) => {
            this.room = data;
            //console.log('room data loaded');
            baseDataLoad.room = true;

            if(baseDataLoad.room && baseDataLoad.assets)
                document.dispatchEvent(this.events.dataLoaded);
        },
        (error) => {
            console.log('Error loading room info', error)
        })

        this.LoadingManagerGlobal.loadFile('data/content.json', true, (data) => {
            this.contents = data;
            //console.log('content data loaded');
        },
        (error) => {
            console.log('Error loading contens info', error)
        })


    }

    downloadObjectAsJson(exportObj, exportName){
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj, null, "\t"));
        var downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href",     dataStr);
        downloadAnchorNode.setAttribute("download", exportName + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    requestFullScreen() {
        var doc = window.document;
        var docEl = doc.documentElement;
      
        var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
        var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
      
        if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
          requestFullScreen.call(docEl);
        }
        else {
          cancelFullScreen.call(doc);
        }
    }

    loadJSON(path, success, error)
    {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function()
        {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (success)
                        success(JSON.parse(xhr.responseText));
                } else {
                    if (error)
                        error(xhr);
                }
            }
        };
        xhr.open("GET", path, true);
        xhr.send();
    }

    /*
    loadData() {
        this.loadJSON( "assets/data.json", 
        ( data ) => {
            this.data = data;
            this.dataLoaded = true;
            //console.log('data loaded');
            document.dispatchEvent(this.events.dataLoaded);
            this.init();
        },
        (error) => {
            console.error('error loading file', error)
        });
        
    }*/

    getCurrentTitle() {
        return this.currentNode != null ? this.currentNode.title : "Stryker";
    }

    /*  ============================
                Navigation
        ============================
    */

    infoBlink() {
        //TODO: info logo blink
    }

    // Used for checking if a Back button if needed, between other things
    isFirstNode() {
        if(this.currentNode != null) {
            return this.currentNode.type == 0 ? true : false
        }
        else
            return true;
    }

    getNavTitle() {
        if(this.currentNode != null) {

            /*
            NODE TYPES
            0:     Start Node (Welcome). Must be unique
            1:     3D category
            2:     2D catgory
            3:     3D System
            4:     3D product
            5:     2D product
            */
            
            switch(this.currentNode.type) {
                case 0:
                case 1:
                case 2:
                case 4:
                case 5:
                    return this.lang.get('Navigation')
                case 3:
                    return this.lang.get('See products')

            }
        }
        else
            return ''
    }

    getNextNavPoints() {
        if(this.currentNode != null)
            return this.currentNode.children;
        else
            return []
    }

    updateContentPanel() {



        if(this.currentNode != null) {
            //this.contentPanel = await this.getPanelContentForCurrent();
            var content = this.contents.find( (x) => x.id == this.currentNode.id)

            this.contentPanel.title = content.title
            this.contentPanel.subtitle = content.subtitle
            this.contentPanel.desc = content.desc


            this.LoadingManagerGlobal.loadFile('data/contents/'+content.contentHTML, false, (content) => {
                this.contentPanel.contentHTML = content
                document.dispatchEvent(this.events.contentPanelUpdated)
            }, (error) => {
                console.error(error)
            })
        }
        else {
            this.contentPanel = {
                title: '',
                subtitle: '',
                desc: '',
                contentHTML: ''
            }
            document.dispatchEvent(this.events.contentPanelUpdated)
        }

        

    }

    openRelatedProduct(node) {
        //console.log('opening related product', node)

        var content = this.contents.find( (x) => x.id == node.id)

        if(content != undefined) {
            this.relatedPanel.title = content.title
            this.relatedPanel.subtitle = content.subtitle
            this.relatedPanel.desc = content.desc

            if(content.contentHTML != "") {
                this.LoadingManagerGlobal.loadFile('data/contents/'+content.contentHTML, false, (content) => {
                    this.relatedPanel.contentHTML = content
                    document.dispatchEvent(this.events.relatedPanelUpdated)
                    
                }, (error) => {
                    console.error(error)
                })
            }
            else {
                this.relatedPanel.contentHTML = ""
                document.dispatchEvent(this.events.relatedPanelUpdated)
            }

            this.relatedPanelOpen = true;
        }

        
    }

    getHelpMini() {
        if(this.viewMode.map)
            return this.lang.get('help_map')
        else if( this.currentNode != null) {
            switch(this.currentNode.type) {
                case 0:
                case 1:
                case 2:
                    return this.lang.get('help_nav')
                case 3:
                case 4:
                case 5:
                    return this.lang.get('help_product')
                
            }
        }

        return ''
        
    }

}